import { render } from "./Player.vue?vue&type=template&id=77687e68"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"
script.render = render

export default script